// External Imports
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Internal Imports
import WarningModal from "../components/UI/WarningModal";
import ConfirmModal from "../components/UI/ConfirmModal";
import ResponseModal from "../components/UI/ResponseModal";
import IssueModal from "../components/UI/IssueModal";

/** ========================================================================
 * * Utility Context
 * This context provides utility functions to the app that require using hooks.
 * This is useful for functions that are used in multiple components.
 * ========================================================================== */

// Create Context
export const UtilityContext = createContext({
  navigate: () => {},
  goBack: () => {},
  warning: "",
  response: "",
  confirm: {},
  setWarning: () => {},
  setResponse: () => {},
  setConfirm: () => {},
  setIssue: () => {},
});

// External Setters
export let utilSetters;

// Context Provider
export const UtilityContextProvider = ({ children }) => {
  // Initialize Hooks
  const navigation = useNavigate();

  // Initialize states
  const [warning, setWarning] = useState();
  const [confirm, setConfirm] = useState();
  const [issue, setIssue] = useState();
  const [response, setResponse] = useState();

  // * Utility Functions

  // Navigate to a new page
  const navigate = (path, e, options = {}) => {
    if (options.newTab || e?.ctrlKey || e?.metaKey) window.open(path, "_blank");
    else navigation(path, options);
  };

  // Navigate Back
  const goBack = () => navigation(-1);

  // Set External Setters
  useEffect(() => {
    utilSetters = {
      setWarning,
      setConfirm,
      setResponse,
      setIssue,
    };
  }, []);

  return (
    <UtilityContext.Provider
      value={{
        navigate,
        goBack,
        warning,
        response,
        setResponse,
        setWarning,
        setConfirm,
        setIssue,
      }}
    >
      <WarningModal
        open={warning ? true : false}
        setOpen={setWarning}
        warning={warning}
      />
      <ConfirmModal
        open={confirm ? true : false}
        setOpen={setConfirm}
        confirm={confirm}
      />
      <ResponseModal
        open={response ? true : false}
        setOpen={setResponse}
        response={response}
      />
      <IssueModal
        open={issue ? true : false}
        setOpen={setIssue}
        issue={issue}
      />
      {children}
    </UtilityContext.Provider>
  );
};
